import { doc, getDoc, setDoc, collection } from 'firebase/firestore';
import { db } from '../config/firebase';

const ADMIN_EMAILS = [
  'xavier@shopiweb.fr',
  // Add other admin emails here
];

export const initializeUser = async (userId: string, email: string) => {
  try {
    const usersRef = collection(db, 'users');
    const userRef = doc(usersRef, userId);
    
    const userDoc = await getDoc(userRef);
    
    if (!userDoc.exists()) {
      const isAdmin = ADMIN_EMAILS.includes(email);
      await setDoc(userRef, {
        role: isAdmin ? 'admin' : 'user',
        email,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      });
      return isAdmin;
    }
    
    return userDoc.data().role === 'admin';
  } catch (error) {
    console.error('Error initializing user:', error);
    return false;
  }
};

export const checkIsAdmin = async (userId: string): Promise<boolean> => {
  try {
    const userRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userRef);
    
    if (userDoc.exists()) {
      const userData = userDoc.data();
      return userData.role === 'admin';
    }
    
    return false;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};